import { Sparkles, CheckCircle2, Trophy, Medal, Clock, Flame, Crown, Lock } from 'lucide-react';

const iconMap = {
  sparkles: Sparkles,
  check: CheckCircle2,
  trophy: Trophy,
  medal: Medal,
  clock: Clock,
  flame: Flame,
  crown: Crown,
};

export default function Badges({ badges = [], compact = false }) {
  if (!badges.length) return null;
  return (
    <div className={`grid gap-3 ${compact ? 'grid-cols-3 md:grid-cols-6' : 'grid-cols-2 md:grid-cols-3'}`}>
      {badges.map((b, i) => {
        const Icon = iconMap[b.icon] || Sparkles;
        return (
          <div
            key={b.id}
            data-testid={`badge-${b.id}`}
            className={`p-4 rounded-2xl border transition-all ${
              b.unlocked
                ? 'border-orange-800/60 bg-gradient-to-br from-orange-950/40 to-transparent'
                : 'border-stone-800 bg-stone-900/40 opacity-60'
            }`}
          >
            <div className="flex items-center justify-between mb-2">
              <Icon size={compact ? 18 : 22} className={b.unlocked ? 'text-orange-400' : 'text-stone-500'} />
              {!b.unlocked && <Lock size={12} className="text-stone-600" />}
            </div>
            <div className={`font-display ${compact ? 'text-base' : 'text-xl'} leading-tight`}>{b.title}</div>
            {!compact && <div className="text-stone-400 text-xs mt-1">{b.desc}</div>}
          </div>
        );
      })}
    </div>
  );
}
